import React from "react";
import ReactDOM from "react-dom";
import LayountMain from "./pslayout";
import LayountAdmin from "./adminlayout";
import Improve from "./improve";
import { StylesProvider, createGenerateClassName } from "@mui/styles";
import { BrowserRouter } from "react-router-dom";
// import HelmetMetaData from "components/MataManage/HelmetMetaData";
const generateClassName = createGenerateClassName({
  productionPrefix: "psaccApp",
});
require("./_css/BootstrapTable.css");
require("./_css/App.css");
const getRoute = () => {
  return window.location.pathname !== "/manage";
};
const Improveval = process.env.REACT_APP_IMPROVE;
ReactDOM.render(
  <BrowserRouter>
    <StylesProvider generateClassName={generateClassName}>
      <div className="container">
        {getRoute() ? (
          Improveval !== "true" ? (
            <LayountMain />
          ) : (
            <Improve />
          )
        ) : (
          <LayountAdmin />
        )}
      </div>
    </StylesProvider>
  </BrowserRouter>,

  document.getElementById("root")
);
